import { ListOfAnalytics } from "../components/utils/constants.";
import * as Constants from "../constants";
import cookies from "react-cookies";

export function analyticsGet(startDate, endDate, chartId) {
  let token = cookies.load(Constants.ACCESS_TOKEN);

  let url = ListOfAnalytics.find((item) => item.id === chartId).api.replace("startDate", startDate);
  url = url.replace("endDate", endDate);
  return Constants.apiAction({
    url,
    method: Constants.REQUEST_GET,
    accessToken: token,
    onSuccess: analyticsSuccess,
    onFailure: analyticsFailure,
    label: Constants.ANALYTICS_REQUESTED,
  });
}

function analyticsSuccess(data) {
  return {
    type: Constants.ANALYTICS_SUCCESS,
    payload: data,
  };
}

function analyticsFailure(data, router) {
  const errorMsg = "Couldn't load api...";
  return {
    type: Constants.ANALYTICS_FAILURE,
    payload: errorMsg,
  };
}
